module.exports = __webpack_public_path__ + "img/guide_4.bc993e2f.png";